<template>
  <div>
    <div :id="inputDivId" class="form-group comp-start">
      <label for="name" class="control-label input-label">{{
        info.message
      }}</label>
      <input
        ref="qustInput"
        v-model="input_val"
        type="text"
        class="form-control form-control-lg questions-input"
        :placeholder="info.prompt"
      />
    </div>
  </div>
</template>
<script lang="ts">
import EventEmitter from "@/utils/eventEmitter";
import { Component, Watch, Prop } from "vue-facing-decorator";
import { Vue } from "vue-facing-decorator";

@Component({})
export default class InputText extends Vue {
  public input_val = "";
  public inputDivId = "";

  @Prop()
  public info!: any;

  @Watch("info.values")
  onChangeInfo() {
    this.onUpdateInfo();
  }

  mounted() {
    this.onUpdateInfo();
  }
  onUpdateInfo() {
    this.input_val = "";
    this.inputDivId = "input-" + this.info.id;
    if (this.info && this.info.values && this.info.values.length > 0) {
      this.input_val = this.info.values[0];
    }
    const context = this;
    setTimeout(function () {
      context.getInputPosition();
    }, 1000);

    this.$nextTick(() => {
      setTimeout(() => {
        if (this.$refs.qustInput && this.$refs.qustInput !== undefined) {
          (this.$refs.qustInput as any).focus();
        }
      }, 500);
    });
  }
  getInputPosition() {
    const inputElem: any = document.getElementById("" + this.inputDivId);
    if (inputElem && this.info.guidance && this.info.guidance !== null) {
      const inputPosition = inputElem.getBoundingClientRect();
      EventEmitter.emit("APP_INPUT_POSITION", inputPosition.top);
    }
  }
}
</script>

<style lang="scss">
.input-label {
  font-weight: 500;
  font-size: 13px;
  line-height: 19px;
  color: #231f20;
}
.questions-input {
  border: none;
  height: 85px;
  background-color: unset !important;
  border-left: 2px solid rgba(183, 183, 183, 0.3) !important;
  border-radius: unset;
  font-size: 46px;
  color: #0345bd !important;
  padding-top: 5px;
  padding-left: 37px;
  margin-top: 30px;
}
.form-group > .form-control:focus {
  box-shadow: none !important;
}
.form-group input::placeholder {
  font-weight: 300;
  font-size: 42px;
  color: #b7b7b7;
}
</style>
